exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#create-script-fnb legend {\n  font-size: unset;\n}\n#create-script-fnb input[type=checkbox] {\n  width: 20px;\n  height: 20px;\n}", ""]);
